import React, { useState } from "react";

const AssessedToggle = ({ props }) => {
  const { assessed, setAssessed } = props;
  return (
    <div className="flex flex-col items-center justify-center bg-gray-100 mb-4">
      <h2 className="text-2xl font-semibold mb-4">Assessment Status</h2>
      <div className="flex gap-4">
        <button
          className={`px-6 py-2 rounded-2xl font-medium shadow-md transition-all 
            ${
              assessed === "not_assessed"
                ? "bg-red-500 text-white"
                : "bg-white text-red-600 border border-red-500"
            }`}
          onClick={() => setAssessed("not_assessed")}
        >
          Not Assessed
        </button>
        <button
          className={`px-6 py-2 rounded-2xl font-medium shadow-md transition-all 
            ${
              assessed === "assessed"
                ? "bg-green-500 text-white"
                : "bg-white text-green-600 border border-green-500"
            }`}
          onClick={() => setAssessed("assessed")}
        >
          Assessed
        </button>
      </div>

      {assessed && (
        <p className="mt-6 text-lg">
          Current Status:{" "}
          <span className="font-semibold text-blue-600">
            {assessed === "assessed" ? "Assessed" : "Not Assessed"}
          </span>
        </p>
      )}
    </div>
  );
};

export default AssessedToggle;
